import React from "react";

const StatusBadge = ({ status, type = "plan" }) => {
  const getStyles = () => {
    if (type === "installment") {
      switch (status) {
        case "PAID":
          return "bg-success-light text-success-dark";
        case "PENDING":
          return "bg-warning-light text-warning-dark";
        case "MISSED":
          return "bg-danger-light text-danger-dark";
        default:
          return "bg-neutral-light text-neutral-dark";
      }
    }
    
    // Plan status
    switch (status) {
      case "ACTIVE":
        return "bg-success-light text-success-dark";
      case "MATURED":
        return "bg-secondary-light text-secondary-dark";
      case "REDEEMED":
        return "bg-primary-light text-primary-dark";
      case "CANCELLED":
        return "bg-danger-light text-danger-dark";
      default:
        return "bg-neutral-light text-neutral-dark";
    }
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStyles()}`}>
      {status}
    </span>
  );
};

export default StatusBadge;
